import "./setupProcess"; // must be first
import React, { useEffect, useState } from "react";
import "./App.css";
import { jwtDecode } from "jwt-decode";  // correct import for v4
import { ZoomMtg } from "@zoom/meetingsdk";

// Zoom SDK setup
ZoomMtg.setZoomJSLib("https://source.zoom.us/4.1.0/lib", "/av");
ZoomMtg.preLoadWasm();
ZoomMtg.prepareWebSDK();
ZoomMtg.i18n.load("en-US");

function App() {
  const [role, setRole] = useState(0); // 0 = participant, 1 = host
  const [buttonText, setButtonText] = useState("Join Meeting");
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [meetingNumber, setMeetingNumber] = useState("6808717664"); // you can pass via token later
  const [password, setPassword] = useState("835733");



  // 🔐 Decode JWT to get role and user details
  useEffect(() => {
    try {
      const pathname = window.location.pathname;
      const token = pathname.slice(1); // example: /eyJhbGciOi...
      if (token) {
        const user = jwtDecode(token);

        const name =
          user.firstName.charAt(0).toUpperCase() + user.firstName.slice(1);
        setUsername(name);
        setEmail(user.email);

        // Role Logic
        const type = user.user_type?.toLowerCase();
        if (type === "teacher" || type === "admin") {
          setRole(1);
          setButtonText("Start Meeting");
        } else {
          setRole(0);
          setButtonText("Join Meeting");
        }

        // You can pass meeting info in token too
        if (user.meetingNumber) setMeetingNumber(user.meetingNumber);
        if (user.passWord) setPassword(user.passWord);
      }
    } catch (error) {
      console.error("JWT decode failed:", error);
    }
  }, []);

  // --- CONFIG --- //
  //const sdkKey = "J4FSApY6RFekNW0evi2A"; // replace
  const sdkKey = process.env.REACT_APP_ZOOM_SDK_KEY || "J4FSApY6RFekNW0evi2A";
  //const authEndpoint = "http://localhost:4000"; // your local signature server
  //const authEndpoint = process.env.REACT_APP_ZOOM_MEETING_SERVER || "http://localhost:4000";
  // const authEndpoint = "http://159.65.154.219:4000";
  const authEndpoint = "https://classes.lorrainemusicacademy.org/zoom-signature";




  const leaveUrl = "https://lorrainemusicacademy.org/home/meetings";

  const getSignature = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch(authEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          meetingNumber,
          role,
        }),
      });

      const data = await res.json();
      if (data.signature) {
        startMeeting(data.signature);
      } else {
        alert("Failed to get signature");
        console.error(data);
      }
    } catch (err) {
      console.error("Signature fetch failed:", err);
    }
  };

  const startMeeting = (signature) => {
    document.getElementById("zmmtg-root").style.display = "block";

    ZoomMtg.init({
      leaveUrl: leaveUrl,
      success: () => {
        console.log("Zoom SDK initialized successfully");

        ZoomMtg.join({
          signature,
          // sdkKey,
          meetingNumber,
          passWord: password,
          userName: username || "Guest",
          userEmail: email,
          success: () => {
            console.log("Joined meeting successfully");
          },
          error: (error) => {
            console.error("Join error", error);
          },
        });
      },
      error: (error) => {
        console.error("Init error", error);
      },
    });
  };

  return (
    <div className="App">
      <main>
        <h1>Please {buttonText} the Zoom Meeting</h1>
        <button onClick={getSignature}>{buttonText}</button>
      </main>
    </div>
  );
}

export default App;
